(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('TipoOrdenamientoDeleteController',TipoOrdenamientoDeleteController);

    TipoOrdenamientoDeleteController.$inject = ['$uibModalInstance', 'entity', 'TipoOrdenamiento'];

    function TipoOrdenamientoDeleteController($uibModalInstance, entity, TipoOrdenamiento) {
        var vm = this;

        vm.tipoOrdenamiento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TipoOrdenamiento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
